/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SMSTemplateEditor/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SMSTemplateEditor({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication/SMSTemplateEditor"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventActionDataSmsValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.sms',
})
let eventActionDataSmsTemplateEnabledValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.sms_template.enabled',
})
let aggregateData = fromAggregate.and(eventActionDataSmsValueData, eventActionDataSmsTemplateEnabledValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}